<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showRating" style="margin-bottom: 0" class="label-input">Rating</label>
            <input type="checkbox" v-model="fields['data-show-rating']" id="showRating" />
          </div>
          <v-row>
            <v-col cols="12" md="4">
              <v-rating
                color="warning"
                background-color="#c1c1c1"
                empty-icon="mdi-star-outline"
                full-icon="mdi-star"
                half-icon="mdi-star-half-full"
                hover
                length="5"
                size="35"
                :value="fields['rating-stars']"
                @input="handleChangeRatingStars"
              ></v-rating>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields['rating-text']" label="Text" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Grid Product</label>
          <v-text-field v-model="fields['title-grid']" label="Title" />
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['text-color']" label="Text Color" />
                  <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="head"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['background-color']"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field v-model="fields['background-color']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="wrap-products-form">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 10px">Products</label>
            <v-btn small text color="primary" @click="handleAddProduct">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Product</span>
            </v-btn>
          </div>
          <div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['body-grid']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Product {{ i + 1 }}</span>
                    <!-- <div class="pr-2 color-red" @click.stop="handleRemoveProduct(i)">
                      <span>Remove</span>
                    </div> -->
                    <v-btn icon @click.stop="handleRemoveProduct(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="wrap-product-form">
                    <v-text-field v-model="item.url" label="Url" />
                    <div class="mb-5">
                      <label> Image</label>
                      <UploadImage
                        @callback="obj => handleUploadImage(obj, i)"
                        :image="{ imageSrc: item.image }"
                        :height="`250`"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemoveUpload(i)"
                      />
                    </div>
                    <ckeditor :editor="editor" v-model="item['content']" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'product-grid-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        ['rating-stars']: 0,
        ['data-show-rating']: false,
        ['rating-text']: '',
        ['body-grid']: [],
        ['text-color']: '',
        ['background-color']: '',
        ['topPadding']: true,
        ['bottomPadding']: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleUploadImage(obj, index) {
      this.fields['body-grid'][index].image = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields['body-grid'][index].image = '';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionProductGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddProduct() {
      this.fields['body-grid'].push({
        url: '',
        image: '',
        content: '',
      });
    },
    handleRemoveProduct(index) {
      this.fields['body-grid'].splice(index, 1);
    },
    handleChangeRatingStars(value) {
      const num = Number(value);
      this.fields['rating-stars'] = num;
      this.fields['rating-text'] = this.changeTextReting(num, this.fields['rating-text']);
    },
    changeTextReting(value, text = 'Rated 4.9/5 by 12,000+ happy pet owners') {
      return text.replace(/\d+(\.\d+)?\/5/, `${value}/5`);
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
